import {useEffect, useRef, useState} from "react";

import {AmplitudeHomeMatchAction, trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT, HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT} from "../constants/home_match_basic_resignation";
import {
    hitGtmHomeMatchBasicFlowResignationModal,
    HOME_MATCH_BASIC_DISABLE_LABEL,
    HOME_MATCH_BASIC_KEEP_ENABLED_LABEL
} from "../tracking/home_match_basic_flow_gtm_events";
import type {
    IHomeMatchBasicPreferencesFlowAmplitudeItemContext,
    IHomeMatchBasicPreferencesFlowTrackingContext
} from "../types/HomeMatchBasicPreferencesFlowTypes";

type HomeMatchBasicResignationLoadingAction = "keepEnabled" | "disable" | null;

interface IUseHomeMatchBasicResignationActionsParams {
    isOpen: boolean;
    isSaving: boolean;
    onDisable: () => void;
    onKeepEnabled: () => void;
    onClose: () => void;
    trackingContext?: IHomeMatchBasicPreferencesFlowTrackingContext;
    amplitudeItemContext?: IHomeMatchBasicPreferencesFlowAmplitudeItemContext;
}

const trackHomeMatchOnOffConfirm = (
    amplitudeItemContext: IHomeMatchBasicPreferencesFlowAmplitudeItemContext | undefined,
    value: string,
    rpHmMatchAction: AmplitudeHomeMatchAction
) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_hm_on_off_modal_confirm",
        buttonCategory: "rp_hm_on_off_modal",
        value,
        itemId: amplitudeItemContext?.itemId ?? null,
        propertyId: amplitudeItemContext?.propertyId ?? null,
        rpHmMatchAction,
        ...(amplitudeItemContext?.authPlacement !== undefined && {additionalEventProperties: {auth_placement: amplitudeItemContext.authPlacement}})
    });
};

export const useHomeMatchBasicResignationActions = (params: IUseHomeMatchBasicResignationActionsParams) => {
    const {isOpen, isSaving, onDisable, onKeepEnabled, onClose, trackingContext, amplitudeItemContext} = params;
    const wasViewTracked = useRef(false);
    const wasSaving = useRef(false);
    const [loadingAction, setLoadingAction] = useState<HomeMatchBasicResignationLoadingAction>(null);

    useEffect(() => {
        if (!isOpen) {
            wasViewTracked.current = false;
            return;
        }

        if (trackingContext && !wasViewTracked.current) {
            wasViewTracked.current = true;
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "view",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory
            });
        }
    }, [isOpen, trackingContext]);

    useEffect(() => {
        if (!isOpen) {
            setLoadingAction(null);
            wasSaving.current = false;
            return;
        }

        if (wasSaving.current && !isSaving) {
            setLoadingAction(null);
        }

        wasSaving.current = isSaving;
    }, [isOpen, isSaving]);

    const handleClose = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "close",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory
            });
        }

        onClose();
    };

    const handleKeepEnabled = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "click",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory,
                eventLabel: HOME_MATCH_BASIC_KEEP_ENABLED_LABEL
            });
        }

        trackHomeMatchOnOffConfirm(amplitudeItemContext, HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT, "hm_on");

        setLoadingAction("keepEnabled");
        onKeepEnabled();
    };

    const handleDisable = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "click",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory,
                eventLabel: HOME_MATCH_BASIC_DISABLE_LABEL
            });
        }

        trackHomeMatchOnOffConfirm(amplitudeItemContext, HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT, "hm_off");

        setLoadingAction("disable");
        onDisable();
    };

    return {
        isKeepEnabledLoading: isSaving && loadingAction === "keepEnabled",
        isDisableLoading: isSaving && loadingAction === "disable",
        handleClose,
        handleKeepEnabled,
        handleDisable
    };
};
import {useEffect, useRef, useState} from "react";

import {AmplitudeHomeMatchAction, trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT, HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT} from "../constants/home_match_basic_resignation";
import {
    hitGtmHomeMatchBasicFlowResignationModal,
    HOME_MATCH_BASIC_DISABLE_LABEL,
    HOME_MATCH_BASIC_KEEP_ENABLED_LABEL
} from "../tracking/home_match_basic_flow_gtm_events";
import type {
    IHomeMatchBasicPreferencesFlowAmplitudeItemContext,
    IHomeMatchBasicPreferencesFlowTrackingContext
} from "../types/HomeMatchBasicPreferencesFlowTypes";

type HomeMatchBasicResignationLoadingAction = "keepEnabled" | "disable" | null;

interface IUseHomeMatchBasicResignationActionsParams {
    isOpen: boolean;
    isSaving: boolean;
    onDisable: () => void;
    onKeepEnabled: () => void;
    onClose: () => void;
    trackingContext?: IHomeMatchBasicPreferencesFlowTrackingContext;
    amplitudeItemContext?: IHomeMatchBasicPreferencesFlowAmplitudeItemContext;
}

const trackHomeMatchOnOffConfirm = (
    amplitudeItemContext: IHomeMatchBasicPreferencesFlowAmplitudeItemContext | undefined,
    value: string,
    rpHmMatchAction: AmplitudeHomeMatchAction
) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_hm_on_off_modal_confirm",
        buttonCategory: "rp_hm_on_off_modal",
        value,
        itemId: amplitudeItemContext?.itemId ?? null,
        propertyId: amplitudeItemContext?.propertyId ?? null,
        rpHmMatchAction,
        ...(amplitudeItemContext?.authPlacement !== undefined && {additionalEventProperties: {auth_placement: amplitudeItemContext.authPlacement}})
    });
};

export const useHomeMatchBasicResignationActions = (params: IUseHomeMatchBasicResignationActionsParams) => {
    const {isOpen, isSaving, onDisable, onKeepEnabled, onClose, trackingContext, amplitudeItemContext} = params;
    const wasViewTracked = useRef(false);
    const wasSaving = useRef(false);
    const [loadingAction, setLoadingAction] = useState<HomeMatchBasicResignationLoadingAction>(null);

    useEffect(() => {
        if (!isOpen) {
            wasViewTracked.current = false;
            return;
        }

        if (trackingContext && !wasViewTracked.current) {
            wasViewTracked.current = true;
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "view",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory
            });
        }
    }, [isOpen, trackingContext]);

    useEffect(() => {
        if (!isOpen) {
            setLoadingAction(null);
            wasSaving.current = false;
            return;
        }

        if (wasSaving.current && !isSaving) {
            setLoadingAction(null);
        }

        wasSaving.current = isSaving;
    }, [isOpen, isSaving]);

    const handleClose = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "close",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory
            });
        }

        onClose();
    };

    const handleKeepEnabled = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "click",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory,
                eventLabel: HOME_MATCH_BASIC_KEEP_ENABLED_LABEL
            });
        }

        trackHomeMatchOnOffConfirm(amplitudeItemContext, HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT, "hm_on");

        setLoadingAction("keepEnabled");
        onKeepEnabled();
    };

    const handleDisable = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "click",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory,
                eventLabel: HOME_MATCH_BASIC_DISABLE_LABEL
            });
        }

        trackHomeMatchOnOffConfirm(amplitudeItemContext, HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT, "hm_off");

        setLoadingAction("disable");
        onDisable();
    };

    return {
        isKeepEnabledLoading: isSaving && loadingAction === "keepEnabled",
        isDisableLoading: isSaving && loadingAction === "disable",
        handleClose,
        handleKeepEnabled,
        handleDisable
    };
};
